function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { headingSizes, textStyles } from './../../../../theme/foundations/typography';
import { transparentize } from '../../../../utils/color';
import { asMultiStyleConfig } from '../../../../utils/theme';
export var NIFooter = asMultiStyleConfig({
  parts: ['mainContainer', 'divider', 'subMenuTitle', 'authoritiesContainer', 'authoritiesHeading', 'menuItem', 'legalInfoContainer', 'legalInfoText', 'legalInfoLogos', 'logoLinkStyle'],
  baseStyle: {
    mainContainer: {
      pt: {
        base: '2.25rem',
        md: '2rem',
        lg: '1.75rem'
      },
      pb: {
        base: '1.75rem',
        md: '2.75rem'
      },
      backgroundColor: 'blue.700'
    },
    divider: {
      borderColor: transparentize('blue.600', 0.2),
      mb: '2rem'
    },
    subMenuTitle: _objectSpread(_objectSpread({}, textStyles['heading-sm']), {}, {
      color: 'white',
      mb: '.75rem'
    }),
    menuItem: _objectSpread(_objectSpread({
      display: 'inline-block',
      mb: '.75rem'
    }, headingSizes['sm']), {}, {
      letterSpacing: '-0.2px',
      fontWeight: 'normal',
      color: 'blue.300',
      border: '1px solid',
      borderColor: 'transparent',
      _hover: {
        color: 'white',
        textDecoration: 'underline'
      },
      _focus: {
        py: 0,
        borderRadius: '.25rem',
        borderColor: 'blue.300',
        boxShadow: "0 0 3px 2px #2182EB"
      },
      _active: {
        color: 'blue.300'
      }
    }),
    authoritiesContainer: {
      pt: {
        base: '3rem',
        lg: '3.5rem'
      },
      pb: {
        base: '2.5rem',
        md: '4.625rem',
        lg: '4rem'
      },
      bg: 'neutral.15'
    },
    authoritiesHeading: _objectSpread(_objectSpread({}, textStyles['heading-sm']), {}, {
      color: 'grey.970',
      mb: {
        base: '2rem',
        md: '3rem',
        lg: '2rem'
      }
    }),
    legalInfoContainer: {
      pt: {
        base: '1.875rem',
        md: '2.5rem',
        lg: '2.375rem'
      },
      pb: {
        base: '2.25rem',
        md: '3rem',
        lg: '2.375rem'
      },
      backgroundColor: 'blue.700'
    },
    legalInfoText: {
      flexBasis: {
        base: '100%',
        lg: '60%'
      },
      alignItems: 'center',
      mb: {
        base: '1.75rem',
        md: '1.25rem',
        lg: 0
      },
      fontSize: {
        base: 'xs',
        md: 'sm'
      },
      lineHeight: 'short',
      letterSpacing: '-0.2px',
      color: 'white'
    },
    legalInfoLogos: {
      flex: {
        base: '0 0 100%',
        lg: '0 0 40%'
      }
    },
    logoLinkStyle: {
      border: '1px solid',
      borderColor: 'transparent',
      display: 'inline-block',
      _focus: {
        border: '1px solid',
        borderColor: 'blue.300',
        borderRadius: '4px',
        boxShadow: '0 0 3px 2px #2182EB'
      }
    }
  }
});